import React from 'react';
import { createRoot } from 'react-dom/client';
import './ui/theme.css';
import './ui/allStyles';
import App from './App';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
